import { Component, OnInit, signal } from '@angular/core';
import { PaymentService, ProductDisplay } from '../payment.service';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'sub-pricing',
  standalone: true,
  imports:[RouterLink, CommonModule],
  templateUrl: './sub-pricing.component.html',
  styleUrls: ['./sub-pricing.component.css']
})
export class SubPricingComponent implements OnInit{

  billingToggle: boolean = true;

  activeFaqIndex: number | null = null;
  products = signal<ProductDisplay[]>([]);
  selectedProduct: ProductDisplay = null;



  constructor(private paymentService: PaymentService){}

  toggleFaq(index: number): void {
    this.activeFaqIndex = this.activeFaqIndex === index ? null : index;
    console.log(this.activeFaqIndex);
  }

  async ngOnInit(): Promise<void> {
    const p = await this.paymentService.getProducts();
    this.products.set(p);
    this.selectedProduct = this.products[0];

  }

}
